import { RefObject, useEffect, useRef } from "react";
import useExplorerItems from "@/common/hooks/useExplorerItems.ts";
import { ExplorerItems } from "@/types/types.ts";
import { addUserEventSourceListener } from "@/common/hooks/event-source/useUserApiEventSource.ts";
import { SEGMENT_EXPORTED_TRACK_CREATED } from "@/common/sse-api-event-source-message-types";

function useSegmentExportedTrackCreated(eventSourceRef: RefObject<EventSource | null>) {
  const exportedSegmentIdListRef = useRef<string[]>([]);
  const [, setExplorerItems] = useExplorerItems();

  // SEGMENT_EXPORTED_TRACK_CREATED Listener
  useEffect(() => {
    if (!eventSourceRef.current) return;

    const handleTrackSegmentCreated = (e: MessageEvent) => {
      const { explorerItem, amountOfSegments, uploadNumber } = JSON.parse(e.data);

      setExplorerItems((prevItems) => {
        const updatedItems = {
          [explorerItem.id]: explorerItem,
          ...prevItems,
        } as ExplorerItems;

        if (!exportedSegmentIdListRef.current.includes(explorerItem.id)) {
          exportedSegmentIdListRef.current.push(explorerItem.id);
        }

        const resortedExplorerItems = exportedSegmentIdListRef.current
          .map((id) => updatedItems[id])
          .filter((item) => item !== undefined) // Zorg dat er geen undefined in zit
          .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));

        const prevItemsWithoutResorted = Object.fromEntries(
          Object.entries(updatedItems).filter(([id]) => !exportedSegmentIdListRef.current.includes(id))
        );

        if (uploadNumber === amountOfSegments) {
          console.log("FINISHED");
          exportedSegmentIdListRef.current = []; // Reset idList in ref
        }

        return {
          ...Object.fromEntries(
            resortedExplorerItems.map((item) => [
              item.id,
              item
            ])
          ),
          ...prevItemsWithoutResorted,
        } as ExplorerItems;
      });
    };

    const removeListener = addUserEventSourceListener(
      eventSourceRef.current,
      SEGMENT_EXPORTED_TRACK_CREATED,
      handleTrackSegmentCreated
    );

    // Cleanup
    return () => {
      removeListener();
    };
  }, [
    eventSourceRef,
    setExplorerItems
  ]);
}

export default useSegmentExportedTrackCreated;
